import type { RouteObject } from 'react-router-dom'

import { Component as UserAccounts } from '@/modules/advisors/users/pages/[id]/Accounts'
import { Component as UserActionPlan } from '@/modules/advisors/users/pages/[id]/ActionPlan'
import { Component as UserQuestionnaire } from '@/modules/advisors/users/pages/[id]/Questionnaire'
import { Component as UserTransactions } from '@/modules/advisors/users/pages/[id]/Transactions'
import { Component as UserData } from '@/modules/advisors/users/pages/[id]/User'
import { Component as Chat } from '@/modules/advisors/users/pages/chat/AdvisorChat'
import { Component as UsersList } from '@/modules/advisors/users/pages/Users'
import { AdvisorUsersRoutePathsEnum } from '@/modules/advisors/users/routes/advisorsUsersRouteConfig.types'

export const ADVISORS_USERS_ROUTES: RouteObject[] = [
  {
    element: <UsersList />,
    path: AdvisorUsersRoutePathsEnum.USERS,
  },
  {
    element: <UserData />,
    path: AdvisorUsersRoutePathsEnum.USER,
  },
  {
    element: <UserAccounts />,
    path: AdvisorUsersRoutePathsEnum.ACCOUNTS,
  },
  {
    element: <UserTransactions />,
    path: AdvisorUsersRoutePathsEnum.TRANSACTIONS,
  },
  {
    element: <UserActionPlan />,
    path: AdvisorUsersRoutePathsEnum.ACTION_PLAN,
  },
  {
    element: <UserQuestionnaire />,
    path: AdvisorUsersRoutePathsEnum.QUESTIONNAIRE,
  },
  {
    element: <Chat />,
    path: AdvisorUsersRoutePathsEnum.CHAT,
  },
]
